export function isValueEsists(value: any) {
  return value !== undefined && value !== null;
}

export function isNumber(value: any) {
  return (
    typeof value === "number" &&
    !isNaN(value) &&
    value !== undefined &&
    value !== null
  );
}
